import buildIndicatorScopeKey from '@Application/Indicators/buildIndicatorScopeKey';
import type { IndicatorScope } from '@Application/Indicators/IndicatorScope';

type Args = {
	scope: IndicatorScope;
};

class FetchSubjectIndicators {
	readonly scope: IndicatorScope;
	readonly queryKey: string;

	constructor(args: Args) {
		this.scope = args.scope;
		this.queryKey = buildIndicatorScopeKey(args.scope);

		Object.freeze(this);
	}
}

export default FetchSubjectIndicators;
